module.exports = __webpack_public_path__ + "assets/img/free_36.ff5453bc.png";